import { render, staticRenderFns } from "./shipment.vue?vue&type=template&id=aa0aecf4&"
import script from "./shipment.vue?vue&type=script&lang=js&"
export * from "./shipment.vue?vue&type=script&lang=js&"
import style0 from "./shipment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports